{
  "dashboard": {
    "title": "Bảng điều khiển",
    "welcomeBack": "Chào mừng trở lại, {{name}}! Đây là những gì đang diễn ra hôm nay.",
    "defaultUser": "Người dùng",
    "customize": {
      "button": "Tùy chỉnh",
      "title": "Tùy chỉnh bảng điều khiển",
      "reset": "Đặt lại mặc định",
      "empty": "Chưa có widget nào được hiển thị.",
      "emptyAction": "Tùy chỉnh bảng điều khiển",
      "sizeLabel": "Kích thước widget",
      "sizeSm": "Nhỏ",
      "sizeMd": "Vừa"
    },
    "widgetSettings": {
      "title": "Cài đặt widget",
      "limitRows": "{{count}} dòng",
      "status": {
        "all": "Tất cả trạng thái",
        "upcoming": "Chưa đến",
        "arrived": "Đã đến"
      }
    },
    "appointmentsSummary": {
      "new": "Lịch mới",
      "followUp": "Lịch tái khám",
      "arrived": "Đã đến",
      "upcoming": "Chưa đến"
    },
    "actions": {
      "createAppointment": "Tạo lịch hẹn",
      "createLead": "Tạo lead",
      "createPatient": "Thêm bệnh nhân",
      "createTask": "Tạo task"
    },
    "kpis": {
      "leads": "Lead hôm nay",
      "appointments": "Lịch hẹn hôm nay",
      "revenue": "Doanh thu hôm nay"
    },
    "trend": "{{sign}}{{value}}% so với hôm qua",
    "cards": {
      "todaysAppointments": "Lịch hẹn hôm nay",
      "recentLeads": "Lead mới hôm nay",
      "recentPatients": "Bệnh nhân mới hôm nay",
      "appointmentTypes": "Loại lịch hẹn hôm nay",
      "revenueTrend": "Xu hướng doanh thu",
      "upcomingAppointments": "Lịch hẹn còn lại hôm nay",
      "onLeaveToday": "Nghỉ phép hôm nay",
      "pendingLeaveRequests": "Đơn nghỉ phép chờ duyệt",
      "overdueLabOrders": "Đơn lab trễ hạn",
      "overdueTasks": "Task quá hạn của tôi",
      "overdueTasksAll": "Task quá hạn",
      "inProgressTasks": "Task đang thực hiện của tôi",
      "inProgressTasksAll": "Task đang thực hiện"
    },
    "viewAll": "Tất cả",
    "calendar": "Lịch",
    "empty": {
      "noAppointmentsToday": "Không có lịch hẹn nào hôm nay",
      "noRecentLeads": "Không có lead mới hôm nay",
      "noRecentPatients": "Không có bệnh nhân mới hôm nay",
      "noUpcomingAppointments": "Không còn lịch hẹn nào hôm nay",
      "noOnLeaveToday": "Không có ai nghỉ phép hôm nay",
      "noPendingLeaveRequests": "Không có đơn nghỉ phép chờ duyệt",
      "noOverdueLabOrders": "Không có đơn lab trễ hạn",
      "noOverdueTasks": "Không có task quá hạn của tôi",
      "noOverdueTasksAll": "Không có task quá hạn",
      "noInProgressTasks": "Không có task đang thực hiện của tôi",
      "noInProgressTasksAll": "Không có task đang thực hiện"
    },
    "registeredOn": "Đăng ký vào {{date}}",
    "upcomingAt": "{{date}} lúc {{time}}",
    "chart": {
      "appointmentsSeries": "Lịch hẹn",
      "revenueSeries": "Doanh thu ({{currency}})",
      "monthlyRevenueTitle": "Doanh thu theo tháng"
    },
    "errors": {
      "loadFailed": "Không thể tải dữ liệu bảng điều khiển. Vui lòng thử lại."
    }
  },

  "analytics": {
    "title": "Báo cáo & Phân tích",
    "actions": {
      "exportReport": "Xuất báo cáo",
      "printReport": "In báo cáo",
      "refreshData": "Làm mới dữ liệu",
      "generateReport": "Tạo báo cáo",
      "generateFirst": "Vui lòng tạo báo cáo trước"
    },
    "filters": {
      "clinic": "Phòng khám",
      "allClinics": "Tất cả phòng khám",
      "startDate": "Ngày bắt đầu",
      "endDate": "Ngày kết thúc",
      "periodPlaceholder": "Chọn khoảng ngày"
    },
    "summary": {
      "totalAppointments": "Tổng lịch hẹn",
      "totalPatients": "Tổng bệnh nhân",
      "totalTreatments": "Tổng điều trị"
    },
    "tabs": {
      "revenue": "Doanh thu",
      "patients": "Bệnh nhân",
      "appointments": "Lịch hẹn",
      "treatments": "Điều trị"
    },
    "charts": {
      "revenue": "Doanh thu",
      "patientTrend": "Xu hướng bệnh nhân",
      "newPatients": "Bệnh nhân mới",
      "returningPatients": "Bệnh nhân tái khám",
      "patientsByClinic": "Bệnh nhân theo phòng khám",
      "patients": "Bệnh nhân",
      "newVsReturning": "Bệnh nhân mới & tái khám",
      "appointmentTrend": "Xu hướng lịch hẹn",
      "visitKind": "Phân loại lịch",
      "createdBy": "Người tạo lịch",
      "byDentist": "Theo bác sĩ",
      "byAppointmentType": "Theo loại lịch",
      "booked": "Đã hẹn",
      "appointmentCount": "Số lịch",
      "unknownCreator": "Không rõ",
      "showed": "Đã đến",
      "noShow": "Không đến",
      "scheduled": "Đã đặt lịch",
      "completed": "Hoàn thành",
      "cancelled": "Đã hủy",
      "appointmentStatus": "Trạng thái lịch hẹn",
      "treatmentTrend": "Xu hướng kế hoạch điều trị",
      "treatmentDistribution": "Phân bổ điều trị",
      "treatmentDetails": "Chi tiết điều trị",
      "count": "Số lượng"
    },
    "appointmentSummary": {
      "total": "Tổng lịch",
      "showRate": "Tỉ lệ đến",
      "noShowRate": "Không đến",
      "cancelRate": "Hủy",
      "rateOfTotal": "{{count}} / {{total}}",
      "deltaCount": "{{sign}}{{count}} {{compare}}"
    },
    "details": {
      "countAppointments": "Số lượng: {{count}} lịch hẹn"
    },
    "overview": {
      "cohortHint": "Phễu theo cùng nhóm lead tạo trong kỳ, kể cả khi khám, chốt hoặc thu tiền xảy ra sau kỳ.",
      "sections": {
        "summary": "Doanh thu đã thu",
        "breakdown": "Tăng giảm do đâu",
        "drivers": "Vì sao"
      },
      "collected": "Doanh thu đã thu",
      "compareMom": "so với kỳ trước",
      "compareYoy": "so với cùng kỳ năm trước",
      "mom": "Kỳ trước",
      "yoy": "Cùng kỳ năm ngoái",
      "deltaAmount": "{{sign}}{{amount}} {{compare}}",
      "deltaRate": "{{sign}}{{rate}}%",
      "points": "{{sign}}{{value}} điểm",
      "trend": "12 tháng gần nhất",
      "trendNote": "Cột tháng cuối dừng ở ngày kết thúc kỳ đang chọn.",
      "trendCurrent": "Kỳ này",
      "trendComparison": "Cùng kỳ năm trước",
      "waterfall": "Từ kỳ trước đến kỳ này, theo nhóm điều trị",
      "previousTotal": "Kỳ trước",
      "currentTotal": "Kỳ này",
      "grew": "Tăng mạnh",
      "fell": "Giảm mạnh",
      "emptySide": "Không có nhóm nào",
      "clinics": "Theo phòng khám",
      "unallocated": "Không phân nhóm",
      "planAdvance": "Tạm ứng chưa gán dịch vụ",
      "other": "Nhóm khác",
      "unknownSource": "Không rõ nguồn",
      "customerNew": "Khách mới",
      "customerReturning": "Khách cũ",
      "customerUnknown": "Chưa phân loại",
      "drillServices": "Dịch vụ chịu phần lớn mức đổi trong nhóm này",
      "drillSources": "Nguồn lead chịu phần lớn mức đổi",
      "drillStage": "Chặng này so với kỳ đối chiếu",
      "noDrill": "Không tách thêm được.",
      "stages": {
        "leads": "Lead",
        "examined": "Đã khám",
        "accepted": "Đã chốt kế hoạch",
        "paid": "Đã thu tiền"
      },
      "rates": {
        "exam": "Tỷ lệ đã khám",
        "close": "Tỷ lệ chốt",
        "avgPlan": "Giá trị kế hoạch trung bình",
        "collect": "Tỷ lệ thu trên kế hoạch đã chốt"
      },
      "conversion": "{{rate}}% so với chặng trước",
      "stage": "Chặng",
      "count": "Số lượng",
      "planValue": "Giá trị kế hoạch đã chốt",
      "collectedCohort": "Đã thu trên nhóm lead"
    },
    "treatments": {
      "total": "Tổng kế hoạch điều trị",
      "confirmed": "Đã xác nhận",
      "unconfirmed": "Chưa xác nhận",
      "cancelled": "Huỷ",
      "empty": "Không có kế hoạch điều trị trong kỳ này"
    },
    "patients": {
      "total": "Tổng số bệnh nhân",
      "converted": "Đã chuyển đổi",
      "notConverted": "Chưa chuyển đổi",
      "byGroup": "Theo nhóm bệnh nhân",
      "byAge": "Theo độ tuổi",
      "byCountry": "Theo quốc gia sinh sống",
      "bySource": "Theo nguồn khách",
      "unassignedGroup": "Chưa phân nhóm",
      "unknownAge": "Chưa có ngày sinh",
      "unknownCountry": "Chưa rõ quốc gia",
      "empty": "Không có hồ sơ bệnh nhân tạo mới trong kỳ này",
      "ageBuckets": {
        "0-12": "0–12",
        "13-17": "13–17",
        "18-24": "18–24",
        "25-34": "25–34",
        "35-44": "35–44",
        "45-54": "45–54",
        "55-64": "55–64",
        "65+": "65+"
      }
    },
    "revenue": {
      "sales": "Doanh số",
      "collected": "Doanh thu",
      "receivable": "Công nợ",
      "averagePerPatient": "Doanh thu TB/KH",
      "totalCollected": "Tổng đã thu",
      "receiptCount": "Số phiếu",
      "averageReceipt": "Phiếu trung bình",
      "delta": "Chênh lệch",
      "previousTotal": "Kỳ trước",
      "trend": "Xu hướng",
      "byClinic": "Theo phòng khám",
      "byDoctor": "Theo bác sĩ đại diện",
      "byConsultant": "Theo bác sĩ tư vấn",
      "byConsultingStaff": "Theo nhân viên tư vấn",
      "byServiceGroup": "Theo nhóm dịch vụ",
      "topServices": "Top 10 dịch vụ có doanh thu cao nhất",
      "byCustomerSource": "Theo nguồn khách hàng",
      "unassignedDoctor": "Chưa gán",
      "unknownMethod": "Không rõ",
      "unknownSource": "Không rõ nguồn",
      "unallocated": "Không phân nhóm",
      "planAdvance": "Tạm ứng chưa gán dịch vụ",
      "empty": "Không có doanh số hay phiếu thu trong kỳ này",
      "section": "Phần",
      "label": "Nhãn",
      "amount": "Số tiền"
    },
    "errors": {
      "generateFirst": "Vui lòng tạo báo cáo trước",
      "loadFailed": "Không thể tải dữ liệu báo cáo",
      "loadClinicsFailed": "Không thể tải danh sách phòng khám"
    },
    "referrers": {
      "referrerCount": "Tổng người giới thiệu",
      "referredPatients": "Tổng bệnh nhân được giới thiệu",
      "revenue": "Doanh thu",
      "chartPatients": "Top 10 người giới thiệu nhiều bệnh nhân nhất",
      "chartRevenue": "Top 10 người giới thiệu có doanh thu cao nhất",
      "chartAverageRevenue": "Top 10 người có doanh thu trung bình cao nhất",
      "chartBySource": "Khách đến từ nguồn nào giới thiệu nhiều nhất",
      "unknownSource": "Không rõ nguồn",
      "sourceEmpty": "Không có khách hàng nào giới thiệu trong kỳ này",
      "empty": "Không có người giới thiệu trong kỳ này",
      "unknownName": "Không rõ tên",
      "series": {
        "patients": "Bệnh nhân",
        "revenue": "Doanh thu",
        "averageRevenue": "Doanh thu trung bình"
      },
      "columns": {
        "name": "Người giới thiệu"
      }
    }
  },
  "referrerList": {
    "search": "Tìm tên, mã hoặc số điện thoại",
    "empty": "Chưa có người giới thiệu trong kỳ này",
    "noFound": "Không tìm thấy người giới thiệu",
    "unknownName": "Không rõ tên",
    "kindPatient": "Bệnh nhân",
    "kindStaff": "Nhân viên",
    "kindExternal": "Đối tác",
    "tabs": {
      "directory": "Người giới thiệu",
      "summary": "Bảng tổng hợp"
    },
    "tabsAria": "Người giới thiệu",
    "filters": {
      "title": "Bộ lọc",
      "kind": "Loại",
      "selectKind": "Chọn loại",
      "allKinds": "Tất cả loại",
      "period": "Kỳ",
      "periodPlaceholder": "Chọn khoảng ngày"
    },
    "columns": {
      "name": "Người giới thiệu",
      "kind": "Loại",
      "code": "Mã",
      "phone": "Số điện thoại",
      "patients": "Bệnh nhân",
      "revenue": "Doanh thu",
      "averageRevenue": "Doanh thu TB"
    }
  },
  "referrerPicker": {
    "addExternal": "Thêm đối tác",
    "hint": "Nhập ít nhất 2 ký tự",
    "empty": "Không tìm thấy"
  },
  "referrerDirectory": {
    "search": "Tìm tên, mã hoặc số điện thoại",
    "empty": "Chưa có người giới thiệu",
    "noFound": "Không tìm thấy người giới thiệu",
    "add": "Thêm người giới thiệu",
    "addTitle": "Thêm người giới thiệu",
    "editTitle": "Sửa người giới thiệu",
    "saveFailed": "Không lưu được người giới thiệu",
    "active": "Đang dùng",
    "inactive": "Ngừng dùng",
    "fields": {
      "kind": "Loại",
      "firstName": "Tên",
      "lastName": "Họ và chữ lót",
      "phone": "Số điện thoại",
      "code": "Mã",
      "notes": "Ghi chú",
      "status": "Trạng thái",
      "patient": "Bệnh nhân",
      "staff": "Nhân viên"
    },
    "placeholders": {
      "kind": "Chọn loại",
      "firstName": "Nhập tên",
      "lastName": "Nhập họ và chữ lót",
      "phone": "Ví dụ: 0901234567",
      "code": "Ví dụ: GT-001",
      "notes": "Ghi chú về người giới thiệu",
      "patient": "Nhập tên hoặc số điện thoại",
      "staff": "Nhập tên hoặc số điện thoại",
      "status": "Chọn trạng thái"
    },
    "filters": {
      "status": "Trạng thái",
      "selectStatus": "Chọn trạng thái",
      "allStatuses": "Tất cả trạng thái"
    },
    "columns": {
      "status": "Trạng thái"
    },
    "validation": {
      "kindRequired": "Chọn loại người giới thiệu",
      "nameRequired": "Nhập họ và tên",
      "patientRequired": "Chọn bệnh nhân",
      "staffRequired": "Chọn nhân viên"
    }
  }
}
